import './Fab.6b5ae1e1cd9bcf7db4e470ac6335f540.css';
export default {"fab":"_fab_16uu6_1","open":"_open_16uu6_1","handler":"_handler_16uu6_1","mainButton":"_mainButton_16uu6_1","fadeIn":"_fadeIn_16uu6_1","rotate":"_rotate_16uu6_1"};